<template>
    <div class="editable-text">
        <editable :value.sync="value"
                  :display-value="isAddress && value &&
                  value.formatted_address ?
                  value.formatted_address: value || ''"
                  :placeholder="placeholder">
            <input-address :input-class="'form-control'"
                           v-if="isAddress"
                           :placeholder="placeholder"
                           :valid.sync="true"
                           slot="editor"
                           @input="resize"
                           @keyup.enter="validate"
                           v-model="editValue"
                           :address.sync="editValue"
                ref="address"
            >
            </input-address>
            <input slot="editor"
                   v-if="!isAddress && !isTextarea"
                   class="editable-input-text"
                   type="text"
                   @input="resize"
                   @keyup.enter="validate"
                   v-model="editValue"
                   :placeholder="placeholder"
                ref="address">
            <textarea slot="editor"
                v-if="!isAddress && isTextarea"
                class="editable-input-text"
                @input="resize"
                @keyup.enter="validate"
                v-model="editValue"
                :placeholder="placeholder"
                ref="address">
            </textarea>
        </editable>
    </div>
</template>

<style scoped
       lang="less">
    @import './variables';

    @border-size: 1px;

    .editable-text {
        display: inline-block;
    }

    .editable-text {
        .input-address {
            min-width: 250px;
            input {
                min-width: 250px;
            }
        }
    }

    input {
        border: 0;
        background-color: @color-edit;
        box-sizing: content-box;
        margin: -@border-size 0;

        &:focus {
            outline: @border-size solid @color-hover;
        }
    }
</style>

<script type="text/ecmascript-6">
    import Editable from './Editable';
    import InputAddress from '../form/InputAddress';

    export default {
        components: {
            Editable,
            InputAddress
        },
        props: {
            value: {
                twoWay: true,
                /**
                 * if val equals 0, it will be considered as false, so we
                 * won't show the real value. We need to cast 0 to string
                 * @param val
                 * @returns {*}
                 */
                coerce: function (val) {
                    if (val === 0) return val + '';
                    return val;
                }
            },
            placeholder: {
                'default': 'Éditer...'
            },
            isAddress: {
                'default': false
            },
            isTextarea: {
                'default': false
            }
        },
        data() {
            return {
                editValue: ''
            };
        },
        methods: {
            validate() {
                this.$broadcast('editable:validate', this.editValue);
            },
            resize() {
                const e = this.$el.querySelector('input');

                if (!e) {
                    return;
                }

                const rect = e.getBoundingClientRect();
                const innerWidth = e.clientWidth;
                const outerWidth = rect.width;

                const style = getComputedStyle(e);

                let extra = 0;
                extra += parseFloat(style['border-left-width']);
                extra += parseFloat(style['border-right-width']);
                extra += parseFloat(style['padding-left']);
                extra += parseFloat(style['padding-right']);

                e.style.width = '0';
                e.style.width = `${e.scrollWidth + outerWidth - innerWidth - extra}px`;
            }
        },
        events: {
            'editable:childStartEdition': function ({width}) {
                this.editValue = this.value;

                this.$nextTick(() => {
                    this.resize();
                    const input = this.$el.querySelector('.editable-input-text');
                    input.style.minWidth = `${width}px`;
                    input.focus();
                });
            },
            'editable:childValidateEdition': function () {
                this.value = this.editValue;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// EditableText.vue?5b69d77d